<template>
  <div class="media-aside mr-1 d-flex align-items-start">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BMediaAside',
  props: {
    verticalAlign: { type: String, default: 'top' },
  },
}
</script>
